import { render, staticRenderFns } from "./BlogTags.vue?vue&type=template&id=316a3005&scoped=true&"
import script from "./BlogTags.vue?vue&type=script&lang=js&"
export * from "./BlogTags.vue?vue&type=script&lang=js&"
import style0 from "./BlogTags.vue?vue&type=style&index=0&id=316a3005&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a3005",
  null
  
)

export default component.exports